import { curry, toLower } from 'lodash/fp'

export const isPhraseInText = curry((phrase, text) =>
  toLower(text).includes(toLower(phrase)),
)

export default isPhraseInText
